import React from "react"
import styles from "./style.js"
import { withStyles } from '@material-ui/core';
import * as apis from "relay/event";
import { getErrorMessage, checkUncatchableError } from "environments/uncatchableErrorStore";
import PublishEventOnWebsite from "./PublishEvent";
import TestForm from "./TestTab"
import ScheduleForm from "./ScheduleTab"
import { Formik, Form } from "formik";
import { getPropertyId } from "common/index.js";
import SocialMediaShare from "./SocialMedia"
import ThanksMail from "./ThanksMail";
import "./style.css"

const ScheduleEvent = ({ classes, id, inviteEmailHtml, showNotification, onChange, inviteScheduledAt, invitedGroups, subject, username, lastTestEmails, lastTestPhones, smsEnabled, onScheduleSMSEmail, getSubmitButtonState, onPublish, timezoneString, timezoneAbbr, ...props }) => {
  const [sendingTest, setSendingTest] = React.useState(false);
  const prevDate = inviteScheduledAt ? inviteScheduledAt : "";
  const [campaignTested, setCampaignTested] = React.useState(props.campaignTested);
  const [expanded, setExpanded] = React.useState("Second");


  const getDefaultOpen = () => {
    if (inviteScheduledAt && props.publishAt && campaignTested) {
      setExpanded("Fourth");
      return;
    }
    if (props.publishAt && campaignTested) {
      setExpanded("Third");
      return;
    }
    if (props.publishAt && !campaignTested) {
      setExpanded("Second");
      return;
    }
    if (!props.publishAt && campaignTested) {
      setExpanded("First");
      return;
    }
  }

  React.useEffect(() => {
    getDefaultOpen();
  }, [])



  const handleExpandedPanel = (panel) => {
    if (panel === expanded)
      setExpanded("");
    else
      setExpanded(panel);
  };


  const onSend = async (data) => {
    try {
      setSendingTest(true)
      let recipients = [...data.emails, ...data.phones].toString()
      let payload = {
        id,
        recipients,
        bodyHtml: "auto",
        subject
      }
      let response = await apis.testInvite(payload);
      if (response && response.testInviteEmail && response.testInviteEmail.hyevent) {
        setCampaignTested(response.testInviteEmail.hyevent.campaignTested);
        showNotification("Test Invites has been sent successfully", "success")
      }

      setSendingTest(false)
      const uncachebleError = getErrorMessage(checkUncatchableError("testInviteMutation"));
      if (uncachebleError) {
        showNotification(uncachebleError, "error");
      } else {
        setExpanded("Second")
      }
    }
    catch (error) {
      showNotification("Something went wrong", "error");
      console.log("error: ", error)
      setSendingTest(false)
    }

  }

  const renderTestForm = (props) => {
    return (
      <Form>
        <TestForm smsEnabled={smsEnabled} classes={classes} expanded={expanded} sendingTest={sendingTest} inviteScheduledAt={inviteScheduledAt} handleExpandedPanel={handleExpandedPanel} campaignTested={campaignTested} {...props} />
      </Form>
    )
  }

  const renderScheduleForm = (props) => {
    return (
      <Form>
        <ScheduleForm timezoneAbbr={timezoneAbbr} classes={classes} propertyId={getPropertyId()} expanded={expanded} handleExpandedPanel={handleExpandedPanel} onChange={onChange} id={id} prevDate={prevDate} invitedGroups={invitedGroups} getSubmitButtonState={getSubmitButtonState} timezoneString={timezoneString} {...props} />
      </Form>
    )
  }


  const onSubmit = async (values) => {
    switch (expanded) {
      case "First":
        await onPublish(values);
        if (campaignTested) {
          setExpanded("Third");
        } else {
          setExpanded("Second");
        }
        break;
      case "Second":
        await onSend(values);
        if (props.publishAt) {
          setExpanded("Third");
        } else {
          setExpanded("First");
        }
        break;
      case "Third":
        await onScheduleSMSEmail(values);
        setExpanded("Fourth");
        break;
      case "Fourth":
        break;
    }
  }


  return (
    <div className={classes.rootContainer}>
      <Formik initialValues={{
        emails: lastTestEmails ? lastTestEmails.split(',') : [username],
        phones: lastTestPhones ? lastTestPhones.split(',') : [],
      }}
        onSubmit={onSubmit}
      >
        {renderTestForm}

      </Formik>

      <div className={classes.fieldContainer}>
        <PublishEventOnWebsite id={id} classes={classes} expanded={expanded} handleExpandedPanel={handleExpandedPanel} getSubmitButtonState={getSubmitButtonState} onClick={onSubmit} timezoneString={timezoneString} timezoneAbbr={timezoneAbbr} {...props} />
      </div>
      <div className={`${(props.publishAt && campaignTested) ? "" : classes.disabledStyle}`}>
        <div className={classes.fieldContainer}>
          <Formik
            initialValues={{
              invitedGroups: [],
              inviteScheduleAt: ""
            }}
            onSubmit={onSubmit}
          >
            {renderScheduleForm}
          </Formik>
        </div>
        <div className={classes.fieldContainer}>
          <SocialMediaShare id={id} showNotification={showNotification} classes={classes} expanded={expanded} handleExpandedPanel={handleExpandedPanel} timezoneString={timezoneString}  {...props} />
        </div>
      </div>
      {/* <ThanksMail
        id={id}
        showNotification={showNotification}
        expanded={expanded}
        handleExpandedPanel={handleExpandedPanel}
        {...props}
      /> */}
    </div>
  )
}

export default (withStyles)(styles)(ScheduleEvent);